import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { CustomerRegister } from './add-customer/customerRegister.model';
import { Messages } from './messages.model';
import { SystemData } from './systemData.model';

@Injectable({
  providedIn: 'root'
})
export class OptionService {


  Send_notification_headers: any

  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {



    this.Send_notification_headers =
      new HttpHeaders().set("Authorization", "key=AAAAl8StOkw:APA91bG93uZCAM_abkUDapdy2RzTKwt8epmkry0zcdCwnEl4rEexU6Av1YzARA0jjFsP-txT_1pVFmtctc8AqmNHrLx_ifGhLJ3reOceN9TLOMu5p8zRdTdpM_7d73PPqPr67V6AJJY9")

  }


  getAllCustomers(userId: string) {
    return this.http.get<[]>(this.global.APIURL + "users/customerlist/" + userId);
  }

  getAllMandoobs() {
    return this.http.get<[]>(this.global.APIURL + "users/mandoobslist");
  }

  updateUserBalance(obj: any) {
    return this.http.put(this.global.APIURLV2 + "users/updateuserbalance", obj);
  }
  //messageType: number, chargedStatus: number
  getMessages() {
    return this.http.get<Messages[]>(this.global.APIURL + "messages");
  }

  getNotSeenMessageCount() {
    return this.http.get<number>(this.global.APIURL + "messages/getnotseen");
  }

  deleteMessages(id: number) {
    return this.http.delete(this.global.APIURL + "messages/" + id);
  }

  updateStatusMessage(id: number, status: number, rejectReason: string) {
    return this.http.put(this.global.APIURL + "messages/updatestatus/" + id + "?status=" + status + "&rejectReason=" + rejectReason, "");
  }

  updateNotSeenMessage() {
    return this.http.put(this.global.APIURL + "messages/updatenotseen", "");
  }

  getDefinitions() {
    return this.http.get<SystemData>(this.global.APIURL + "definitions");
  }

  updateDefinitions(systemData: SystemData) {
    return this.http.put(this.global.APIURL + "definitions", systemData);
  }

  approvedUser(userId: string, userCategoryId: number, mandoobId: number) {

    return this.http.put(this.global.APIURL + "users/approve/" + userId + "/" + userCategoryId + "/" + mandoobId, "");
  }

  getUserCategory() {
    return this.http.get<[]>(this.global.APIURL + "usercategory");
  }

  updateUserCategory(obj: any) {
    return this.http.put(this.global.APIURLV2 + "users/updatecategories", obj);
  }

  deleteUser(userId: string) {
    return this.http.delete(this.global.APIURL + "identity/delete/" + userId);
  }

  ChangeUserStatus(obj: any) {
    return this.http.put(this.global.APIURL + "identity/changeuserstatus", obj);
  }

  sendNotification(obj: any) {
    return this.http.post("https://fcm.googleapis.com/fcm/send", obj, { headers: this.Send_notification_headers });
  }

  createNotifications(notification: any) {
    return this.http.post(this.global.APIURL + "notification", notification);
  }

  registerCustomer(customerReg: CustomerRegister) {
    return this.http.post(this.global.APIURL + "identity/registerbyadmin", customerReg);
  }

  createPermNotifications(permNotification: any) {
    return this.http.post(this.global.APIURL + "permnotification", permNotification);
  }

  // sendOneByOneSMS(mobileNo: string, message: string) {
  //   return this.http.get<any>(this.global.APIURL + "identity/sendOneByOneSMS?mobileNo=" + mobileNo
  //     + "&message=" + message);
  // }

  // sendBulkSMS(obj: any) {
  //   return this.http.post<any>(this.global.APIURL + "identity/sendbulkSMS", obj);
  // }

  // getSMSBallance() {
  //   return this.http.get<any>(this.global.APIURL + "identity/SMSBallance");
  // }

  getSystemSettings(key: string) {
    return this.http.get<any>(this.global.APIURL + "systemsetting/" + key);
  }

  updateSystemSettings(obj: any) {
    return this.http.put<any>(this.global.APIURL + "systemsetting/", obj);
  }

  updatePyticCategory() {
    return this.http.post<any>(this.global.APIURL + "pytic/createCategory", null);
  }

  updatePyticSubCategory() {
    return this.http.post<any>(this.global.APIURL + "pytic/createSubCategory", null);
  }

  updatePyticProduct() {
    return this.http.post<any>(this.global.APIURL + "pytic/createProducts", null);
  }

  updateEfwateercome() {
    return this.http.post<any>(this.global.APIURLV2 + "efawateercom/updatedata", null);
  }

  send2FAToken(obj: any) {
    return this.http.post(this.global.APIURL + "identity/send2FAToken", obj);
  }

}
